import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../services/auth';
import TokenCountdown from './TokenCountdown';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (token) {
      // 初始化token监控
      authService.initTokenMonitor();
    }
  }, [token]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // 验证token是否有效
  const tokenExpiry = authService.getTokenExpiryTime(token);
  if (!tokenExpiry || tokenExpiry <= Date.now()) {
    authService.logout();
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <TokenCountdown />
      {children}
    </>
  );
};

export default PrivateRoute;
